import StandardsProtocolsContainer from "./StandardsProtocolsContainer";

export default StandardsProtocolsContainer;